// src/redux/reducer/profileReducer.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Profile } from "../../authentication/model/Profile";
import { changePasswordThunk, fetchProfileThunk } from "../thunk/profileThunk";

interface ProfileState {
  data: Profile | null;
  error: string | null;
  passwordChangeSuccess: boolean;
}

const initialState: ProfileState = {
  data: null,
  error: null,
  passwordChangeSuccess: false,
};

const profileReducer = createSlice({
  name: "profile",
  initialState,
  reducers: {
    clearProfile: (state) => {
      state.data = null;
      state.error = null;
    },
    resetPasswordChangeStatus: (state) => {
      state.passwordChangeSuccess = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProfileThunk.pending, (state) => {
      state.error = null;
    });
    builder.addCase(fetchProfileThunk.fulfilled, (state, action: PayloadAction<Profile | null>) => {
      state.data = action.payload;
    });
    builder.addCase(fetchProfileThunk.rejected, (state, action) => {
      state.error = action.payload as string;
    });

    builder.addCase(changePasswordThunk.pending, (state) => {
      state.error = null;
      state.passwordChangeSuccess = false;
    });
    builder.addCase(changePasswordThunk.fulfilled, (state) => {
      state.passwordChangeSuccess = true;
    });
    builder.addCase(changePasswordThunk.rejected, (state, action) => {
      state.error = action.payload as string;
      state.passwordChangeSuccess = false;
    });
  },
});

export const { clearProfile, resetPasswordChangeStatus } = profileReducer.actions;
export default profileReducer.reducer;
